/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { availabilityRangeDataSchema } from './availabilityRangeDataSchema';

export const workloadSchemeCreateRequestSchema = z.object({
  description: z.string().min(0).max(1000).nullish(),
  isDefault: z.boolean(),
  locationIds: z.array(z.int()).nullish(),
  moveLocationMembers: z.boolean(),
  name: z.string().min(0).max(255),
  get range() {
    return availabilityRangeDataSchema;
  },
});
